import React, { useState, useEffect } from 'react';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import ReactTable from 'components/ReactTable/ReactTable';
import Button from 'components/CustomButtons/Button.js';
import { nDecimal, formatDate } from 'hooks/Pipe';
import { Toasty, useToasty } from 'hooks/Toasty';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import GridContainer from 'components/Grid/GridContainer';
import FilterArticle from 'hooks/FilterArticle';
import { Create, Visibility } from '@material-ui/icons';
import { WithApp } from 'contexts/appContext';
import Box from '@material-ui/core/Box';
import { Link } from 'react-router-dom';

import { wsGet, wsFindBy } from 'services/WService';
import LastPriceModal from './LastPriceModal';
import { useModal } from 'hooks/useModal';
import { TextField } from '@material-ui/core';
import GridItem from 'components/Grid/GridItem';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 80 },

  { Header: 'Cod. Producto', accessor: 'ItemCode', width: 150 },
  { Header: 'Cod.Prod.Prov', accessor: 'FrgnName', width: 200 },
  { Header: 'Producto', accessor: 'ItemName', width: 200 },
  { Header: 'Almacén', accessor: 'WhsName', width: 200 },
  { Header: 'Pre.Original', accessor: 'price', width: 120 },
  { Header: 'Precio', accessor: 'purchase_price', width: 140 },
  { Header: 'Cantidad', accessor: 'quantity', width: 120 },
  { Header: 'UM', accessor: 'UnitMsr', width: 120 },
  { Header: 'NumPerMsr', accessor: 'NumPerMsr', width: 140 },

  
  { Header: 'Id Compra', accessor: 'purchase_id', width: 120 },
  { Header: 'Documento Compra', accessor: 'sunat_number', width: 200 },
  { Header: 'Fecha Doc', accessor: 'tax_date', width: 150 },

  { Header: 'Proveedor', accessor: 'CardName', width: 250 },

  { Header: 'Marca', accessor: 'mark_description', width: 150 },
  { Header: 'Categoría', accessor: 'category_description', width: 150 },
  { Header: 'Línea', accessor: 'line_description', width: 150 },
  { Header: 'Família', accessor: 'family_description', width: 150 },

  // { Header: 'Cod. Producto', accessor: 'ItemCode', width: 150 },
  // { Header: 'Cod.Prod.Prov', accessor: 'FrgnName', width: 200 },
  // { Header: 'Producto', accessor: 'ItemName', width: 200 },

  // { Header: 'Cantidad', accessor: 'quantity', width: 120 },
  // { Header: 'UM', accessor: 'UnitMsr', width: 120 },
  // { Header: 'NumPerMsr', accessor: 'NumPerMsr', width: 140 },
  // { Header: 'Pre.Original', accessor: 'price', width: 120 },
  // { Header: 'Precio', accessor: 'purchase_price', width: 140 },
  { Header: 'Estado', accessor: 'state', width: 140 },
  { Header: 'Verificado', accessor: 'verified', width: 140 },
  { Header: 'Fecha creación', accessor: 'created_at', width: 150 },
  { Header: 'Fecha inactivación', accessor: 'inactivation_date', width: 180 },

  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

function LastPurchasePrices(props) {
  const [lastPrices, setLastPrices] = useState([]);
  const [filters, setFilters] = useState({});
  const [dateFilter, setDateFilter] = useState({});
  const [notify, showNotify] = useToasty();
  const [model, setOpen] = useModal();
  const [itemCode, setItemCode] = useState('');
  const [dataLoading, setDataLoading] = useState(false);
  // Se obtiene la informacion del endPoint
  useEffect(() => {
    wsGet('purch/last-purchase-price').then((res) => {
      setLastPrices(res.data);
    });
  }, []);
  // Filtros para realizar la busqueda
  async function loadLastPrices(filter) {
    setDataLoading(true);
    let res = await wsFindBy('purch/last-purchase-price', filter);
    setDataLoading(false);
    if (res.success) {
      console.log('Datos recibidos:', res.data);
      setLastPrices(res.data);
    }
  }

  function search() {
    let searchData = {...dateFilter, ...filters};
    if(itemCode !== ''){
      searchData.ItemCode = itemCode;
    }
    loadLastPrices(searchData);
  }

  return (
    <CardContainer /*title="Listado de últimos precios de compra"*/ title={(<>Listado de últimos precios de compra {dataLoading && <LoadingSpinner />}</>)}>
      <FilterArticle getFilter={(filter) => setFilters(filter)} article warehouse/>
      <FilterCustom dateRange diffRange={3} getFilter={(filter) => setDateFilter(filter)} />
      <GridContainer>
        <GridItem xs={6}>
          <TextField
            label='Código de producto'
            fullWidth
            margin="normal"
            value={itemCode}
            onInput={(e) => {
              setItemCode(e.target.value);
            }}
          />
        </GridItem>
        <GridItem xs={6}>
          <Button onClick={search}>Buscar</Button>
        </GridItem>
      </GridContainer>
      
      <Toasty action={notify} />

      <LastPriceModal
        model={model}
        setOpen={setOpen}
        showNotify={showNotify}
        reload={search}
      />

      <ReactTable
        columns={columns}
        formatDate='DD-MM-YYYY H:mm:ss'
        defaultWidth={3400}
        data={lastPrices.map((item, i) => {
          return {
            ...item,
            num: (
              <div className="actions-right">
                {i + 1}
                <Button
                  justIcon
                  round
                  simple
                  color="warning"
                  className="like"
                  onClick={() => setOpen(item)}
                >
                  <Create />
                </Button>
              </div>
            ),
            purchase_id: (
              <Box display="flex" alignItems="center">
                {item.purchase_id}
                <Link to={`/admin/compras/operaciones/importaciones/${item.purchase_id}`} target="_blank">
                  <Button justIcon round simple color={props.themeContext.buttonColor}>
                    <Visibility />
                  </Button>
                </Link>
              </Box>
            ),
            sunat_number: `${item.ReceiptType}-${item.ReceiptSerie}-${item.ReceiptNumber.padStart(
              8,
              '0',
            )}`,
            tax_date: formatDate(item.tax_date, 'F'),
            FrgnName: item.FrgnName + (item.FrgnName2 !== null ? ' / ' + item.FrgnName2 : ''),

            price: nDecimal(item.price),
            purchase_price: nDecimal(item.purchase_price),

            state: item.state === 'A' ? 'Activo' : 'Inactivo',
            verified: item.verified ? 'Si' : 'No',
            inactivation_date: item.inactivation_date !== null ? formatDate(item.inactivation_date) : ' - ',
          };
        })}
      />
    </CardContainer>
  );
}

export default WithApp(LastPurchasePrices);
